module.exports = __webpack_public_path__ + "img/01.e573789f.jpg";